import { Spinner } from '@cak-legacy/shared-common';
import * as React from 'react';
export const LoadingSpinner = () => (
  <div className="d-inline-block m-0">
    <Spinner loading={true} />
  </div>
);
